import type { Area } from 'react-easy-crop'

const createImage = (url: string) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', (error) => reject(error))
    image.src = url
  })
}

export const getCroppedImage = async (
  fileBase64: string,
  croppedArea: Area,
  type: string,
): Promise<Blob | undefined> => {
  const image: HTMLImageElement = await createImage(fileBase64)
  const canvas = document.createElement('canvas')
  const ctx: CanvasRenderingContext2D | null = canvas.getContext('2d')
  const maxSize = Math.max(image.width, image.height)

  canvas.width = maxSize
  canvas.height = maxSize

  if (!ctx) {
    console.error('Method `getCroppedImage` cannot receive canvas context.')

    return
  }

  ctx.drawImage(image, maxSize / 2 - image.width * 0.5, maxSize / 2 - image.height * 0.5)
  const data = ctx.getImageData(0, 0, maxSize, maxSize)

  canvas.width = croppedArea.width
  canvas.height = croppedArea.height

  ctx.putImageData(
    data,
    0 - maxSize / 2 + image.width * 0.5 - croppedArea.x,
    0 - maxSize / 2 + image.height * 0.5 - croppedArea.y,
  )

  return new Promise((resolve) => {
    canvas.toBlob((Blob) => resolve(Blob || undefined), type)
  })
}
